module.exports = __webpack_public_path__ + "img/intro-strip.4912dbc5.png";